module.exports = "<div [class]=\"showSpinner ? \r\n             'visible spinner center' : \r\n             'hidden spinner center'\" \r\n             [innerHTML]=\"template\">\r\n</div>\r\n<h1 [style.zIndex]=\"zIndex\" \r\n    [class]=\"showSpinner ? \r\n  'visible loading-text' : \r\n  'hidden loading-text'\"> {{loadingText}} </h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader-spinner/loader-spinner.component.html
// module id = ./src/app/shared/loader-spinner/loader-spinner.component.html
// module chunks = main